import Container, {Reducer} from './container'
import RegHolderName from './name'

export {
  Reducer,
  RegHolderName,
}

export default Container



// WEBPACK FOOTER //
// ./src/layout/authorised-layout/current-reg-holder/index.js